export default [ '$q', 'SHOWCASE_CONFIG', 'SHOWCASE_CLIENT', function( $q, SHOWCASE_CONFIG, SHOWCASE_CLIENT ) {

	this.settings = null;

	this.init = init;
	this.get  = get;
	
	function init() {

		try {

			// Tyhjä asetusten rakenne
			var blank_settings = {
				global          : {},
				oeuvre_settings : {},
				views: {
					wall_preview    : {},
					help            : {},
					zoom            : {}
				}
			};

			// Järjestelmän oletusasetukset
			var default_settings = {
			};

			// Muista asetuksista ja ympäristöstä noudettavat asetukset
			var environment_settings = {
				global: {
					client_uid: SHOWCASE_CLIENT && SHOWCASE_CLIENT.uid
				}
			};

			// Yhdistetään erilaiset asetukset yhdeksi paketiksi
			var settings = angular.merge( {}, blank_settings, default_settings, environment_settings, SHOWCASE_CONFIG );

			// Validoidaan asetusten sisältö, jotta se on kauttaaltaan käyttökelpoinen ja sisältää kaiken vaadittavan
			validateSettings( settings );

			this.settings = settings;

		} catch (error) {

			return $q.reject( error );

		}
			
		return $q.resolve( this.get() );
	}
	
	function get() {

		return this.settings;
	}

	function validateSettings( settings ) {

		if (!settings) {
			throw new Error( "Missing showcase configurations!" );
		}

		if (!settings.global.client_oeuvre_list_uid) {
			throw new Error( "No client_oeuvre_list_uid setted!" );
		}

		return settings;
	}
}];
